import "@polymer/polymer/lib/elements/dom-if.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";
import { html, PolymerElement } from "@polymer/polymer/polymer-element.js";

import iconBulletGrey from "../../../../images/icons/icon_bullet_grey.svg";
import iconBulletRed from "../../../../images/icons/icon_bullet_red.svg";
import iconBulletGreen from "../../../../images/icons/icon_bullet_green.svg";
import { _indexModule, checkUserPassedPostTest, checkUserFailedPostTest, checkUserStatusPostTest, checkIsUserEnrolled, getIndexModule, } from "../../../../utils/ecourse";
import "./EcourseListTopik.style";
import "../EcourseModule/EcourseModule";

class EcourseListTopik extends PolymerElement {
  static get template() {
    return html`
      <style include="ecourse-list-topik-style"></style>
        <dom-repeat items="{{listTopik}}" as="module">
          <template>
            <div class="container">
              <dom-if if="{{checkUserPassedPostTest(module, userStatus)}}">
                <template>
                  <div class="module-header">
                    <img src="{{iconBulletGreen}}"/>
                    <p class="text-module"> Modul {{_indexModule(index)}}</p>
                  </div>
                  <div class="container-is-passed"></div>
                </template>
              </dom-if>
              <dom-if if="{{checkUserFailedPostTest(module, userStatus)}}">
                <template>
                  <div class="module-header">
                    <img src="{{iconBulletRed}}"/>
                    <p class="text-module"> Modul {{_indexModule(index)}}</p>
                  </div>
                  <div class="container-is-failed"></div>
                </template>
              </dom-if>
              <dom-if if="{{checkUserStatusPostTest(module, userStatus)}}">
                <template>
                  <div class="module-header">
                    <img src="{{iconBulletGrey}}"/>
                    <p class="text-module">Modul {{_indexModule(index)}}</p>
                  </div>
                  <template is="dom-if" if="{{!checkIsUserEnrolled(userStatus)}}">
                    <div class="container-is-default"></div>
                  </template>
                </template>
              </dom-if>
              <template is="dom-if" if="{{checkIsUserEnrolled(userStatus)}}">
                <div class="module-header">
                  <img src="{{iconBulletGrey}}"/>
                  <p class="text-module">Modul {{_indexModule(index)}}</p>
                </div>
                <div class="container-is-default-not-registered"></div>
              </template>
              <ecourse-module
                index={{index}}
                module={{module}}
                user-status={{userStatus}}
                module-order={{getIndexModule(listTopik,module)}}
                ecourse-id={{ecourseId}}
                ecourse-analytic={{ecourseAnalytic}}
              ></ecourse-module>
            </div>
          </template>
        </dom-repeat>
    `;
  }

  static get properties() {
    return {
      listTopik: {
        type: Array,
      },
      userStatus: {
        type: String
      },
      iconBulletGrey: {
        type: String,
        value: iconBulletGrey
      },
      iconBulletRed: {
        type: String,
        value: iconBulletRed
      },
      iconBulletGreen: {
        type: String,
        value: iconBulletGreen
      },
      _indexModule: {
        type: Function,
        value: () => _indexModule,
      },
      checkUserPassedPostTest: {
        type: Function,
        value: () => checkUserPassedPostTest
      },
      checkUserFailedPostTest: {
        type: Function,
        value: () => checkUserFailedPostTest
      },
      checkUserStatusPostTest: {
        type: Function,
        value: () => checkUserStatusPostTest
      },
      checkIsUserEnrolled: {
        type: Function,
        value: () => checkIsUserEnrolled
      },
      getIndexModule: {
        type: Function,
        value: () => getIndexModule
      },
      ecourseAnalytic: {
        type: Object,
      },
      ecourseId: {
        type: String,
      },
    };
  }
}
customElements.define("ecourse-list-topik", EcourseListTopik);